import React, { useContext, useState } from 'react';
// import { Select } from 'antd';
import Select from 'react-select';
import { getOptionsForAttr } from './coderefs';
import { errorSink } from '../ErrorSink';
import { FormContext } from '../metadata/MDForm';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import { getDefaultValue } from '../metadata/metadata';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  let formatted = previousValue;
  if (/^\d/.test(previousValue)) {
    const prevArray = previousValue.split('/');
    formatted = mapAndFormat(prevArray).join('/');
  }
  return formatted;
};

export const SelectAppUpdater = ({ attr, ...props }) => {
  const options = getOptionsForAttr(attr);
  const form = useContext(FormContext);
  const actions = useContext(ApplicationActionsContext);
  const { setValueByAttr, getValueByAttr } = form;

  const updateInd = !props.disableUpdate;

  let previousValue = getValueByAttr(attr.id);
  if ((previousValue == undefined) || (previousValue == null)) {
    previousValue = getDefaultValue(attr);
  }

  if (!options || !options.list) {
    return errorSink('no coderefs found for attribute' + JSON.stringify(attr));
  }

  let valueSelected = null;
  if (previousValue) {
    const formattedPrevious = formatPrevious(previousValue);
    const menuLabelPrevious = options.index[previousValue];
    valueSelected = {
      value: previousValue,
      label: menuLabelPrevious ? menuLabelPrevious : ((formattedPrevious === '$NaN') ? previousValue : formattedPrevious)
    }
  } else {
    valueSelected = props.value;
  }
  const [selectedValue, setSelectedValue] = useState(valueSelected);

  const handleChange = (selected) => {
    setValueByAttr(attr.id, selected.value);
    setSelectedValue(selected);
    if (updateInd) {
      actions.saveApplication();
    }
  };

  const optionsList = options.list.map((option) => {
        return {
          value: option.value,
          label: option.name,
        };
      });

  return (
    <div style={{ display: 'inline-block', maxWidth: '158px' }}>
      <Select
        {...props}
        aria-label="Select"
        styles={{ ...customStyles, width: '158px' }}
        title="Select"
        openMenuOnFocus
        placeholder={null}
        options={optionsList}
        value={selectedValue}
        onChange={handleChange}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          zIndex: 3,
          colors: {
            ...theme.colors,
            primary25: 'rgb(0, 115, 157, 0.1)',
            primary: 'rgba(0, 115, 157, 0.5)',
            neutral30: 'rgba(0, 115, 157, 0.5)',
          },
        })}
      />
    </div>
  );
};

const customStyles = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};
